import * as Yup from "yup"
import {
    validString,
    state,
    country,
    gender,
} from "Components/shared/helpers/validations"
import { reverseShape } from "Helpers/reverse-shape"
import {
    addressLine,
    email,
    fullName,
    postcode,
    fullContact,
    password,
    idType,
    passport,
    nric,
} from "Utils/validations"

const DriverInfoSchema = Yup.object().shape(
    reverseShape({
        fullName: fullName.required(),
        identityType: idType.required(),
        passportID: Yup.mixed().when("identityType", {
            is: "NRIC",
            then: nric.required(),
            otherwise: passport.required(),
        }),
        mobileNo: fullContact.required(),
        emailAddress: email.required(),
        street1: addressLine.required(),
        street2: addressLine.optional(),
        postcode: postcode.required(),
        city: validString.required(),
        country: country.required(),
        state: state.required(),
        gender: gender.required(),
        // password: password.when("_id", {
        //     is: value => !value,
        //     then: password.required(),
        //     otherwise: password.optional(),
        // }),
        // confirmPwd: Yup.string().when("_id",{
        //     is: value => !value,
        //     then:Yup.string().oneOf([Yup.ref("password")]).required(),
        //     otherwise:Yup.string().optional(),
        // }),
    })
)

export default DriverInfoSchema
